import { useOutletContext } from "react-router-dom";
import { IntegrationShell } from "../common/Shell";
import Instagram from "./Instagram";
import { useInstagramConfiguration } from "./useInstagramConfiguration";
import InstagramConnected from "./InstagramConnected";

export function InstagramIntegration() {
  const { projectId, isViewOnly } = useOutletContext();
  const { instagramConfiguration, fetchInstagramConfiguration } =
    useInstagramConfiguration(projectId);
  const { data, loading, isConfigured } = instagramConfiguration;

  if (loading) {
    return null;
  }

  if (isConfigured) {
    return (
      <IntegrationShell>
        <InstagramConnected
          workspaceId={projectId}
          instagramConfiguration={data}
          fetchInstagramConfiguration={fetchInstagramConfiguration}
          isViewOnly={isViewOnly}
        />
      </IntegrationShell>
    );
  }

  return (
    <IntegrationShell>
      <Instagram
        workspaceId={projectId}
        fetchInstagramConfiguration={fetchInstagramConfiguration}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
